import script from "./ThirdTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ThirdTask.vue?vue&type=script&setup=true&lang=js"

import "./ThirdTask.vue?vue&type=style&index=0&id=7bfe6943&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bfe6943"]])

export default __exports__